<script lang="ts">
  import type { HTMLAttributes } from 'vue'
  export interface DataListItemDescriptionProps {
    class?: HTMLAttributes['class']
  }
</script>

<script setup lang="ts">
  import { cn } from '@gat-ship/vue-components'
  const props = defineProps<DataListItemDescriptionProps>()
</script>

<template>
  <div :class="cn('text-soft truncate text-sm', props.class)">
    <slot />
  </div>
</template>
